import { render } from "./ConfigServer.vue?vue&type=template&id=734c54b2&scoped=true"
import script from "./ConfigServer.vue?vue&type=script&lang=js"
export * from "./ConfigServer.vue?vue&type=script&lang=js"

import "./ConfigServer.vue?vue&type=style&index=0&id=734c54b2&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-734c54b2"]])

export default __exports__